import { useFlags, useFlagsmith } from "flagsmith/react";
import { isNil, omitBy } from "lodash";
import { useRouter } from "next/router";
import { useEffect, useMemo } from "react";
import { useProfile } from "../providers/profileProvider/ProfileProvider";
import { SubsetOfFeatureFlags, Traits } from "./types";

export const useFeatureFlags = (
  requestedFlags: SubsetOfFeatureFlags,
  traits: Partial<Record<(typeof Traits)[number], string>> = {}
) => {
  const flagsmith = useFlagsmith();
  const { profile } = useProfile();
  const { query } = useRouter();
  const { channelLang, translatedVideoID } = query;

  const flagsmithTraits = useMemo(() => {
    return {
      auth0Id: profile.sub,
      translatedVideoId: translatedVideoID,
      targetLanguageCode: channelLang,
      userId: profile.sub,
      userSub: profile.sub,
      ...profile.groups,
      ...traits
    };
  }, [traits, channelLang, translatedVideoID, profile.sub, profile.groups]);
  const traitKeys = useMemo(
    () => Object.keys(flagsmithTraits) as (keyof typeof flagsmithTraits)[],
    [flagsmithTraits]
  );

  // sorted so that the ordering of dependency array is deterministic
  const sortedTraitKeys = useMemo(() => traitKeys.sort(), [traitKeys]);
  const sortedTraitValues = useMemo(
    () => sortedTraitKeys.map(key => flagsmithTraits[key]),
    [sortedTraitKeys, flagsmithTraits]
  );
  useEffect(() => {
    //@ts-ignore
    flagsmith.setTraits(omitBy(flagsmithTraits, isNil));
  }, sortedTraitValues);

  const returnedFlags = useFlags(requestedFlags, sortedTraitKeys);
  return returnedFlags as Partial<typeof returnedFlags>;
};
